import dayjs from 'dayjs';

export const k_permission = {
    costManagementEdit: "costManagementEdit", // 总包管理权限 - deprecated
    costManagementView: "costManagementView", // 总包管理权限 - deprecated
    plmcostsView: "plmcostsView", // 总包管理权限 - new
    plmcostsEdit: "plmcostsEdit", // 总包管理权限 - new
    editValuationPercentage: "editValuationPercentage", // 标准任务百分比编辑权限
    opAdmin: "opAdmin", // 白晓专用
    dashboardView: "dashboardView", // 仪表盘
    dashboardScheduleView: "dashboardScheduleView",
    dashboardWorktimeView: "dashboardWorktimeView",
    dashboardOverallView: "dashboardOverallView", // 项目整体进度
    dashboardCostView: "dashboardCostView",
    milestoneView: "milestoneView", // 标准里程碑查看
    milestoneEdit: "milestoneEdit",// 标准里程碑编辑
    budgetsView: "budgetsView", // 标准任务比例
    costsView: "costsView", // 成本管理
    paymentNodesView: "paymentNodesView", // 收款节点
    wpReportsView: "wpReportsView", // 工作报表
    contractsView: "contractsView", // 合同模板
    teamSpaceView: "teamSpaceView", // 团队空间
    costsStructView: "costsStructView", // 成本结构
    costsHrExecView: "costsHrexecView", // 人力成本执行
    projectControlView: "projectControlView", // 多项目管控节点线
    projectControlEdit: "projectControlEdit", // 多项目管控节点线编辑
    mainContractorPayment: "mainContractorPayment", // 总包应付款管理
    designPackageView: "designPackageView", // 设计总包管理
}
// export const specialNodeNames = ["审图通过", "取得工规证", "甲方内审完成"];
// export const specialNodeCodes = ["65", "70", "78"];
// "方案报批通过","取得工规证"
// export const noLimitSpecialNodes = ["02", "70"];
// 获取前一个节点的索引（考虑分组逻辑）
// groupCode相同且相邻的元素为一组
// 组间控顺序，组内不控顺序可填同一天
export const getPrevNonSpecialNodeIndex = (list: API.PROJECT.Milestone[], currentIndex: number, isActualDate: boolean) => {
    if (currentIndex <= 0) return -1;
    
    const curItem = list[currentIndex];
    if (!curItem) return -1;
    
    const curGroupCode = curItem.groupCode;
    
    // 向上查找第一个有有效时间且 groupCode 不等于当前元素的元素
    for (let i = currentIndex - 1; i >= 0; i--) {
        const item = list[i];
        if (!item) continue;
        
        // 检查是否有有效时间
        const hasDate = isActualDate ? item.actualDate : item.milestoneDate;
        if (!hasDate) continue;
        
        // 检查 groupCode 是否不同
        if (curGroupCode && item.groupCode === curGroupCode) continue;
        
        // 找到目标元素，返回其索引（或其所在组的起始索引）
        if (item.groupCode) {
            // 返回该组的起始索引
            // let groupStartIndex = i;
            // while (groupStartIndex > 0) {
            //     const checkItem = list[groupStartIndex - 1];
            //     if (checkItem && checkItem.groupCode === item.groupCode) {
            //         groupStartIndex--;
            //     } else {
            //         break;
            //     }
            // }
            // return i;
        }
        
        return i;
    }
    
    return -1;
};
export const getMinDateForMilestone = (list: API.PROJECT.Milestone[], currentIndex: number, isActualDate: boolean = false) => {
    if (currentIndex <= 0) return undefined;
    const curItem = list[currentIndex];
    if (!curItem) return undefined;
    
    const prevIndex = getPrevNonSpecialNodeIndex(list, currentIndex, isActualDate);
    if (prevIndex < 0) return undefined;
    
    const prevItem = list[prevIndex];
    if (!prevItem) return undefined;
    
    const dateStr = isActualDate ? prevItem.actualDate : prevItem.milestoneDate;
    if (!dateStr) return undefined;
    
    return dayjs(dateStr).add(1, 'day');
};
const k_milestoneStatus = {
    finished: 1
};
export const isLastGroupNodeCompleted = (list: API.PROJECT.Milestone[], currentIndex: number) => {
    if (currentIndex <= 0) return false;
    if (currentIndex === 1) return true;
    
    const curItem = list[currentIndex];
    if (!curItem) return false;
    
    const curGroupCode = curItem.groupCode;
    
    // 如果当前元素没有 groupCode，直接查找上一个元素
    if (!curGroupCode) {
        const prevItem = list[currentIndex - 1];
        if (prevItem && prevItem.status === k_milestoneStatus.finished) {
            return true;
        }
        return false;
    }
    
    // 当前元素有 groupCode，查找上一组元素
    for (let i = currentIndex - 1; i >= 0; i--) {
        const item = list[i];
        if (!item) continue;
        
        // 跳过同组元素
        if (item.groupCode === curGroupCode) continue;
        
        // 如果上一个元素没有 groupCode 且 status 为 1，则返回 true
        if (!item.groupCode) {
            return item.status === k_milestoneStatus.finished;
        }
        
        // 如果上一个元素有 groupCode，查找同组所有元素
        const targetGroupCode = item.groupCode;
        let groupStartIndex = i;
        let groupEndIndex = i;
        
        // 向左找同组起始
        while (groupStartIndex > 0) {
            const checkItem = list[groupStartIndex - 1];
            if (checkItem && checkItem.groupCode === targetGroupCode) {
                groupStartIndex--;
            } else {
                break;
            }
        }
        
        // 向右找同组结束
        while (groupEndIndex < list.length - 1) {
            const checkItem = list[groupEndIndex + 1];
            if (checkItem && checkItem.groupCode === targetGroupCode) {
                groupEndIndex++;
            } else {
                break;
            }
        }
        
        // 检查同组元素，只要有一个 status 不为 1，则返回 false
        for (let j = groupStartIndex; j <= groupEndIndex; j++) {
            const groupItem = list[j];
            if (!groupItem || groupItem.status !== k_milestoneStatus.finished) {
                return false;
            }
        }
        
        return true;
    }
    
    return false;
};